module.exports = __webpack_public_path__ + "static/media/stop-recording.39766714.svg";